module.exports = __webpack_public_path__ + "img/title.83b2ca36.png";